

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";


// Get Table Data
export const ElEWorkTypeEleMasterTableDataAPI = createAsyncThunk("ElEWorkTypeEleMasterTableData", async ({ data }) => {
    const {
        WorkTypeName,
        M_ELEC_WorkTypeID,
        M_UserID,
        token,
        From,
        To,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Get_M_ELEC_WorkType_Select?M_ELEC_WorkTypeID=${M_ELEC_WorkTypeID}&WorkTypeName=${WorkTypeName}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ElEWorkTypeEleMasterTableDataSlice = createSlice({
    name: "ElEWorkTypeEleMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ElEWorkTypeEleMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ElEWorkTypeEleMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ElEWorkTypeEleMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ElEWorkTypeEleMasterTableDataReducer = ElEWorkTypeEleMasterTableDataSlice.reducer



// InsertUpdate Table Data

export const ElEPost_M_ELEC_Work_InsertUpdateAPI = createAsyncThunk("ElEPost_M_ELEC_Work_InsertUpdate", async ({ data }) => {
    const {
        M_ELEC_WorkTypeID,
        WorkTypeName,
        M_UserID,
        Flag,
        token,
        setLoading,
        handleIsPost,
        handleOnCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    // if (Flag == "Update") {
    //     formdata.append("M_ELEC_PoleID", M_ELEC_PoleID);
    // }
    formdata.append("M_ELEC_WorkTypeID", M_ELEC_WorkTypeID);
    formdata.append("WorkTypeName", WorkTypeName);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setLoading(true)

    let url
    url = `${BaseUrl}/Electrical/Post_M_ELEC_WorkType_InsertUpdate`

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                toastSuccesss(result.message)
                handleOnCloseClick()
                setLoading(false)
                return result.data
            } else {
                setLoading(false)
                toastErrorr(result.message)
            }
            return result
        })
})

const ElEPost_M_ELEC_Work_InsertUpdateSlice = createSlice({
    name: "ElEPost_M_ELEC_Work_InsertUpdate",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ElEPost_M_ELEC_Work_InsertUpdateAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ElEPost_M_ELEC_Work_InsertUpdateAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ElEPost_M_ELEC_Work_InsertUpdateAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const ElEPost_M_ELEC_Work_InsertUpdateReducer = ElEPost_M_ELEC_Work_InsertUpdateSlice.reducer



// Delete Table Data

export const M_ELEC_WorkType_DeleteAPI = createAsyncThunk("M_ELEC_WorkType_Delete", async ({ data }) => {
    const {
        M_ELEC_WorkTypeID,
        M_UserID,
        handleIsPost,
        token,
        handleDeleteCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_ELEC_WorkTypeID", M_ELEC_WorkTypeID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/M_ELEC_WorkType_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
                handleDeleteCloseClick()
            } else {
                toastErrorr(result.message)
                handleDeleteCloseClick()
            }
            return result

        })
})

const M_ELEC_WorkType_DeleteSlice = createSlice({
    name: "M_ELEC_WorkType_Delete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(M_ELEC_WorkType_DeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(M_ELEC_WorkType_DeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;

        });
        builder.addCase(M_ELEC_WorkType_DeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const M_ELEC_WorkType_DeleteReducer = M_ELEC_WorkType_DeleteSlice.reducer